export const SITE_URL = "https://hollowcorp.fr";

export function isEnglishPath(pathname = "") {
  return pathname === "/en" || pathname.startsWith("/en/");
}

export function homePath(pathnameOrEnglish) {
  const english =
    typeof pathnameOrEnglish === "boolean"
      ? pathnameOrEnglish
      : isEnglishPath(pathnameOrEnglish);
  return english ? "/en/home" : "/";
}

export function loginPath(pathnameOrEnglish) {
  const english =
    typeof pathnameOrEnglish === "boolean"
      ? pathnameOrEnglish
      : isEnglishPath(pathnameOrEnglish);
  return english ? "/en/login" : "/fr/connexion";
}

export function clientPath(pathnameOrEnglish) {
  const english =
    typeof pathnameOrEnglish === "boolean"
      ? pathnameOrEnglish
      : isEnglishPath(pathnameOrEnglish);
  return english ? "/en/client-area" : "/fr/espace-client";
}

export function adminPath(pathnameOrEnglish) {
  const english =
    typeof pathnameOrEnglish === "boolean"
      ? pathnameOrEnglish
      : isEnglishPath(pathnameOrEnglish);
  return english ? "/en/admin" : "/fr/admin";
}

const FR_TO_EN = {
  "/": "/en/home",
  "/fr/home": "/en/home",
  "/fr/services": "/en/services",
  "/fr/portfolio": "/en/portfolio",
  "/fr/realisations": "/en/portfolio",
  "/fr/a-propos": "/en/about",
  "/fr/contact": "/en/contact",
  "/fr/mentions-legales": "/en/legal-notice",
  "/fr/connexion": "/en/login",
  "/fr/espace-client": "/en/client-area",
  "/fr/admin": "/en/admin",
  "/fr/exemples/vitrine": "/en/examples/showcase",
  "/fr/exemples/vitrine/menu": "/en/examples/showcase/menu",
  "/fr/exemples/vitrine/contact": "/en/examples/showcase/contact",
};

const EN_TO_FR = Object.fromEntries(
  Object.entries(FR_TO_EN).map(([fr, en]) => [en, fr === "/fr/home" ? "/" : fr])
);

EN_TO_FR["/en/home"] = "/";
EN_TO_FR["/en/projects"] = "/fr/portfolio";

export function alternatePath(pathname) {
  if (isEnglishPath(pathname)) {
    return EN_TO_FR[pathname] || "/";
  }
  return FR_TO_EN[pathname] || "/en/home";
}

export function absoluteUrl(path) {
  if (!path) return SITE_URL;
  if (path.startsWith("http")) return path;
  return `${SITE_URL}${path}`;
}
